// extracted by mini-css-extract-plugin
export default {"recos":"P2-z","productCardOverride":"Q2-z","rowHasBadge":"R2-z"};